import { fetchAll } from './fetch';

export default fetchAll('family');
